'use client';
import React, { FC, Dispatch, SetStateAction } from 'react';
import styles from './category-second.module.scss';
import { Button, Checkbox, Drawer, RadioGroup, Radio } from 'rsuite';
import IconClose from '@/assets/icons/category-second-level/icon-close-circle.svg';
import { CustomAccordion, CustomSlider } from '@/components';
import { Link } from '@/i18n/navigation';
import IconArrowRight from '@/assets/icons/icon-arrow-right.svg';
import { useWindowSize } from 'react-use';
import { AttributeTypes, BrandType } from './secondContent.types';
import { RADIO_BUTTONS } from './data';
import { useTranslations } from 'next-intl';

type SecondContentDrawerProps = {
  openMobileVersion: boolean;
  setOpenMobileVersion: (open: boolean) => void;
  closeMobileMenu: () => void;
  handleChangePrice: (value: [number, number]) => void;
  brandData: BrandType;
  attributes: AttributeTypes[];
  handleChangeAttribute: (
    attribute: AttributeTypes,
    attr: Record<'id' | 'name' | 'slug', string>
  ) => void;
  setIsAvailableForInstallment: Dispatch<SetStateAction<boolean>>;
  isAvailableForInstallment: boolean;
  setIsOnSale: Dispatch<SetStateAction<boolean>>;
  isOnSale: boolean;
  onPercentDiscountAmount: (value: string | number | undefined) => void;
  selectedAttribute: { slug: string; values: string[] }[];
  handleChangeBrands: (brand: string) => void;
};

const SecondContentDrawer: FC<SecondContentDrawerProps> = ({
  openMobileVersion,
  setOpenMobileVersion,
  closeMobileMenu,
  handleChangePrice,
  brandData,
  attributes,
  handleChangeAttribute,
  setIsAvailableForInstallment,
  isAvailableForInstallment,
  setIsOnSale,
  isOnSale,
  onPercentDiscountAmount,
  selectedAttribute,
  handleChangeBrands,
}) => {
  const { width } = useWindowSize();
  const t = useTranslations('Components.category-second-content');
  return (
    <Drawer
      size={width <= 400 ? 'full' : width <= 860 ? 'xs' : 'xs'}
      placement="right"
      open={openMobileVersion}
      onClose={() => setOpenMobileVersion(false)}
      closeButton={false}
    >
      <Drawer.Body style={{ padding: '0' }}>
        <div className={styles.mobileClose}>
          <h3>{t('filters')}</h3>
          <button
            type="button"
            className={styles.drawer__closeButton}
            onClick={closeMobileMenu}
          >
            <IconClose />
          </button>
        </div>
        <div className={styles.drawerContent}>
          <div className={styles.filter}>
            <h3>{t('filters')}</h3>
            <div className={styles.accordion}>
              <CustomAccordion title={t('cost')}>
                <CustomSlider onChange={handleChangePrice} />
              </CustomAccordion>
            </div>
            <div className={styles.accordion}>
              <CustomAccordion title={t('status-product')}>
                <div className={styles.accordion}>
                  <div
                    onClick={() =>
                      setIsAvailableForInstallment(!isAvailableForInstallment)
                    }
                  >
                    <Checkbox
                      color="orange"
                      checked={isAvailableForInstallment}
                    >
                      {t('available-for-installment')}
                    </Checkbox>
                  </div>
                  <div onClick={() => setIsOnSale(!isOnSale)}>
                    <Checkbox color="orange" checked={isOnSale}>
                      {t('product-on-stock')}
                    </Checkbox>
                  </div>
                </div>
              </CustomAccordion>
            </div>
            <div className={styles.accordion}>
              <CustomAccordion title={t('product-on-discount')}>
                <RadioGroup name="radio-group">
                  <div className={styles.accordion}>
                    {RADIO_BUTTONS().map(radio => (
                      <Radio
                        color="orange"
                        key={radio.id}
                        value={radio.value}
                        onChange={onPercentDiscountAmount}
                      >
                        {radio.label}
                      </Radio>
                    ))}
                  </div>
                </RadioGroup>
              </CustomAccordion>
            </div>
            <div className={styles.accordion}>
              <CustomAccordion title={t('brand')}>
                {brandData?.brands?.edges.map(brand => (
                  <div className={styles.accordion} key={brand?.node?.id}>
                    <Checkbox
                      color="orange"
                      onChange={() => handleChangeBrands(brand?.node?.id)}
                    >
                      {brand.node.name}
                    </Checkbox>
                  </div>
                ))}
                {/* <Link href={"#"} className={styles.link}>
                    Показать все <IconArrowRight />
                  </Link> */}
              </CustomAccordion>
            </div>
            {attributes?.map((attribute: any) => (
              <div key={attribute?.node.id} className={styles.accordion}>
                {attribute?.node.withChoices ? (
                  <CustomAccordion title={attribute?.node.name as string}>
                    <div className={styles.accordion}>
                      {attribute?.node.choices?.edges.map(
                        (attr: AttributeTypes) => (
                          <div
                            key={attr.node.id}
                            onClick={() =>
                              handleChangeAttribute(attribute, attr.node)
                            }
                          >
                            <Checkbox
                              color="orange"
                              checked={
                                selectedAttribute[0]?.values[0] ==
                                attr?.node?.slug
                              }
                            >
                              {attr.node.name}
                            </Checkbox>
                          </div>
                        )
                      )}
                    </div>
                  </CustomAccordion>
                ) : null}
              </div>
            ))}
          </div>
          <Button type="button" className={styles.showMore}>
            {t('show-products', { count: 55 })}
          </Button>
        </div>
      </Drawer.Body>
    </Drawer>
  );
};

export default SecondContentDrawer;
